/**
 * Climbable trait module
 */

export * from './climbableTrait';
export * from './climbableBehavior';